import React, { useState } from "react";
import { Alert, Spinner, Container, Modal, } from "react-bootstrap";
import { downloadArquivo, downloadArquivoFrontBoleto, downloadArquivoFront, downloadTodasNotas } from "../../service/api";
import styles from './notas.module.css'
import { PDFDocument, rgb } from "pdf-lib";
import QRCode from "qrcode";
import { useLocation } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";

function Notas() {
    const location = useLocation();
    const responseData = location.state?.responseData;

    const [loading, setLoading] = useState(false);
    const [alertNota, setAlertNota] = useState(false);
    const [alertBoleto, setAlertBoleto] = useState(false);
    const [alertPix, setAlertPix] = useState(false);
    const [alertAll, setAlertAll] = useState(false);
    const [filter, setFilter] = useState("");
    const [sortOrder, setSortOrder] = useState(null);
    const [showDropdown, setShowDropdown] = useState(false);

    async function downloadNota(chave_acesso, pix) {
        setLoading(true);

        try {
            const result = await downloadArquivo(chave_acesso);
            const downloadBlob = await downloadArquivoFront(chave_acesso);

            if (pix) {
                await addQRCodeToPDF(downloadBlob, pix, chave_acesso, "nota");
            } else {
                const url = window.URL.createObjectURL(downloadBlob);
                const linkElement = document.createElement("a");
                linkElement.href = url;
                linkElement.setAttribute("download", `nota_${chave_acesso}.pdf`);
                document.body.appendChild(linkElement);
                linkElement.click();
                document.body.removeChild(linkElement);
                setAlertPix(true);
                setTimeout(() => {
                    setAlertPix(false);
                }, 3000);
            }
            setAlertAll(true);
            setTimeout(() => setAlertAll(false), 5000);
        } catch (error) {
            console.error("Erro ao baixar nota:", error);
        } finally {
            setLoading(false);
        }
    }

    async function downloadMergedPDF(chave_acesso, pix) {
        setLoading(true);

        try {
            const result = await downloadArquivo(chave_acesso);
            const downloadBlob = await downloadArquivoFrontBoleto(chave_acesso);

            if (downloadBlob.type !== "text/html") {
                if (pix) {
                    await addQRCodeToPDF(downloadBlob, pix, chave_acesso, "boleto");
                } else {
                    const url = window.URL.createObjectURL(downloadBlob);
                    const linkElement = document.createElement("a");
                    linkElement.href = url;
                    linkElement.setAttribute("download", `boleto_${chave_acesso}.pdf`);
                    document.body.appendChild(linkElement);
                    linkElement.click();
                    document.body.removeChild(linkElement);
                }
            } else {
                setAlertBoleto(true);
                setTimeout(() => {
                    setAlertBoleto(false);
                    setFilter("")
                }, 3000);
            }
        } catch (error) {
            console.error("Erro ao baixar o Boleto:", error);
        } finally {
            setLoading(false);
            setFilter("")
        }
    }

    async function addQRCodeToPDF(pdfBlob, pixCode, chave_acesso, tipo) {
        try {
            const arrayBuffer = await pdfBlob.arrayBuffer();
            const pdfDoc = await PDFDocument.load(arrayBuffer);
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];

            const qrCodeDataURL = await QRCode.toDataURL(pixCode, {
                errorCorrectionLevel: "H",
            });

            const qrImage = await pdfDoc.embedPng(qrCodeDataURL);
            const { width, height } = qrImage.scale(0.2);

            let x, y;
            let fileName;
            if (tipo === "nota") {
                x = 275;
                y = 105;
                fileName = `nota_${chave_acesso}.pdf`;

                firstPage.drawText("Pague com o PIX", {
                    x: x,
                    y: y + height + 2,
                    size: 6,
                    color: rgb(0, 0, 0),
                });
            } else {
                x = 375;
                y = 40;
                fileName = `boleto_${chave_acesso}.pdf`;

                firstPage.drawText("Pague com o PIX", {
                    x: x + width + 10,
                    y: y + height / 2,
                    size: 12,
                    color: rgb(0, 0, 0),
                });
            }

            firstPage.drawImage(qrImage, {
                x: x,
                y: y,
                width,
                height,
            });

            const pdfBytes = await pdfDoc.save();
            const blob = new Blob([pdfBytes], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            const linkElement = document.createElement("a");
            linkElement.href = url;
            linkElement.setAttribute("download", fileName);
            document.body.appendChild(linkElement);
            linkElement.click();
            document.body.removeChild(linkElement);
        } catch (error) {
            console.error("Erro ao adicionar QR Code ao PDF:", error);
        }
    }

    function formatDate(dateString) {
        const [year, month, day] = dateString.split("-");
        const date = new Date(year, month - 1, day);
        return date.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    }

    const handleFilterChange = (e) => {
        setFilter(e.target.value);
    };

    const filteredNotas = (responseData || []).filter(nota =>
        nota.NUMNF?.toLowerCase().includes(filter.toLowerCase())
    );

    const handleSort = (order) => {
        setSortOrder(order);
        setShowDropdown(false);
    };

    const sortedNotas = [...filteredNotas].sort((a, b) => {
        if (sortOrder === "recentes") {
            return new Date(b.DOCDAT) - new Date(a.DOCDAT);
        } else if (sortOrder === "antigas") {
            return new Date(a.DOCDAT) - new Date(b.DOCDAT);
        }
        return 0;
    });

    const handleDownloadTodas = async () => {
        const chaves = sortedNotas.map(nota => nota.CHAVE_NF);
        if (chaves.length === 0) {
            setAlertNota(true);
            setTimeout(() => setAlertNota(false), 3000);
            return;
        }

        setLoading(true);
        try {
            await downloadTodasNotas(chaves);
            setAlertAll(true);
            setTimeout(() => setAlertAll(false), 5000);
        } catch (error) {
            console.error("Erro ao baixar todas as notas:", error);
            setAlertNota(true);
            setTimeout(() => setAlertNota(false), 3000);
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className={styles['body']}>
            <div className={styles["row-header"]}>
                <a href="/"><img src="./assets/images/logo.png" alt="Logo NF-SIG" className={styles['logo-header']} /></a>


                <button 
                    className={styles["btnSair"]}
                    onClick={() => {
                        window.location.href = "/";
                    }}
                >
                    Sair
                </button>

            </div>
            {loading ? (
                <Container className={styles["container-loding"]}>
                    <div className={styles["spinner-container-text"]}>
                        Processando...
                    </div>
                    <div>
                        <Spinner animation="border" role="status">
                            <span className="sr-only"></span>
                        </Spinner>
                    </div>
                </Container>
            ) : (
                <main className={styles['container']}>
                    {alertBoleto && (
                        <Alert className={styles["alerta"]} variant="danger">Boleto não encontrado ou não aplicável!</Alert>
                    )}
                    {alertPix && <Alert className={styles["alerta"]} variant="danger">Pix não encontrado!</Alert>}
                    {alertNota && (
                        <Alert className={styles["alerta"]} variant="danger">Nenhuma nota encontrada!</Alert>
                    )}
                    {alertAll && (
                        <Alert className={styles["alerta"]} variant="success">Download concluído! Por favor, verifique os arquivos na pasta de downloads do seu computador ou do seu celular.</Alert>
                    )}
                    <div className={styles["row-filter"]}>
                        <div className={styles["input-container"]}>
                            <input
                            type="text"
                            placeholder="Pesquisar por número da nota fiscal..."
                            onChange={handleFilterChange}
                            className={styles["input-form"]}
                            />
                        </div>
                        <div>
                            <button
                            className={styles["btn-baixar"]}
                            onClick={handleDownloadTodas}
                            >
                            Baixar todos os anexos
                            </button>
                        </div>
                    </div>

                    <div className={styles["container_tabela"]}>
                        {filteredNotas.length > 0 ? (
                            <div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Número</th>
                                            <th className={styles["dataTh"]}>
                                                Data
                                                <button
                                                    className={styles["botaoFiltro"]}
                                                    onClick={() => setShowDropdown(!showDropdown)}
                                                >
                                                    <FaChevronDown />
                                                </button>
                                                {showDropdown && (
                                                    <Modal size="sm" show={setShowDropdown} onHide={() => setShowDropdown(false)}>
                                                        <Modal.Header closeButton>
                                                            <Modal.Title>Ordenar por:</Modal.Title>
                                                        </Modal.Header>
                                                        <Modal.Body>
                                                            <div className={styles["dropdown"]}>
                                                                <button className={styles["btn"]} onClick={() => handleSort("recentes")}>Mais recentes</button>
                                                                <button className={styles["btn"]} onClick={() => handleSort("antigas")}>Mais antigas</button>
                                                            </div>
                                                        </Modal.Body>
                                                    </Modal>
                                                )}
                                            </th>
                                            <th>Valor</th>
                                            <th>Arquivos</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedNotas.map((nota, index) => (
                                            <tr key={index}>
                                                <td>{nota.NUMNF.startsWith("0") ? nota.NUMNF.slice(1) : nota.NUMNF}</td>
                                                <td>{formatDate(nota.DOCDAT)}</td>
                                                <td>R$ {nota.VALOR}</td>
                                                <td className={styles['arquivos']}>
                                                    <button
                                                        className={styles["btn"]}
                                                        onClick={() => downloadNota(nota.CHAVE_NF, nota.PIX_QRCODE)}
                                                    >
                                                        Baixar Nota
                                                    </button>
                                                    <button
                                                        className={styles["btn"]}
                                                        onClick={() => downloadMergedPDF(nota.CHAVE_NF, nota.PIX_QRCODE)}
                                                    >
                                                        Baixar Boleto
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <div>
                                <Alert variant="danger" className={styles['danger']}>
                                    Nenhuma nota encontrada para o filtro aplicado!
                                </Alert>
                                <a href="./"><button className={styles["btnVoltar"]}>Voltar para a tela inicial</button></a>
                            </div>
                        )}
                    </div>

                    <img className={styles['logo_brasal']} src="/assets/images/logo_brasal.png" alt="Logo Brasal Refrigerantes" />
                </main>
            )}
        </main>
    ) 
}

export default Notas;
